import React, { useState, useEffect, useContext, useRef } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { AuthContext } from '../../App.js'
import { Button, IconButton, ButtonGroup, Table, TableHead, TableBody, TableRow, TableCell, TextField, InputAdornment, Divider, makeStyles, useMediaQuery } from '@material-ui/core'
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { useSwipeable } from 'react-swipeable'
import { isMobile } from 'react-device-detect'
import './index.css'
import COLORS from '../../colors'
import Header from '../Header'
import Loading from '../LoadingComponent'
import ModalShiftClose from '../ModalShiftClose'
import ModalSendReport from '../ModalSendReport'
import ModalLogoutAlert from '../ModalLogoutAlert'
import Confirmation from '../ConfirmationComponent'
import moment from 'moment'
import axios from 'axios'
import { getHostName } from '../../base.js'
import {ReactComponent as TotalReport} from '../../assets/total_report.svg'
import {ReactComponent as Arrow} from '../../assets/arrow.svg'
import {ReactComponent as ArrowDown} from '../../assets/arrow_down.svg'
import {ReactComponent as Search} from '../../assets/search.svg'
 
const useStyles = makeStyles((theme) => ({
	container: {
	  display:'flex',
	  felxDirection: 'row',
	  justifyContent: 'center',
	  paddingBottom: '1rem',
	  paddingLeft: '1rem', 
	  paddingRight: '1rem'    
	},
	textField1: {
		background: '#fff',
		 
	 
		 
	},
	textField2: {
		background: '#fff',
		 
		 
		marginLeft:'0.6rem',
	},
	input: {
		background: '#F2F2F2',
	    borderRadius: '2rem',
		fontSize: '0.84rem',
		fontColor: COLORS.blue,
		marginRight: '-0.6rem',
		fontWeight: 'bold'
	},
	table: {
		width:'100%',       
  	},
	tableRow: {
		'&:hover': {
			  zIndex: '1000',
			  backgroundColor: COLORS.gray,
		}
  	},
  	arrow:{
		padding:'1rem',
		paddingTop: '1.4rem',
		margin:0,
	 
  	},
  	idHead: {
		padding:'1rem',
		paddingTop:'0.6rem',
        paddingBottom:'0.6rem',
		margin:0,
		color:COLORS.darkGray,
		fontSize:'0.8rem',
		fontWeight:'400', 
  	},
  	dateHead: {
		margin:0,
		color:COLORS.darkGray,
		fontSize:'0.8rem',
		fontWeight: '400',
  	},
  	amountHead: {
		margin:0,
		paddingRight:0,
		color:COLORS.darkGray,
		fontSize:'0.8rem',
		fontWeight: '400',
	},	
  	idBody: {
		padding:'1rem',
		color: COLORS.blue,
		fontWeight: '700',    
  	},
  	dateBody:{
		padding:0,
		color: '#9EA5AD',
		fontWeight: '400',
  	},
	amountBody: {
		padding:0,
		fontWeight: '700',

	},   
	btnGroupActive: {
		display: 'flex',
		justifyContent: 'center',
		padding: '1rem',
	},
	btnGroupClosed: {
		display: 'flex',
		justifyContent: 'center',
		padding: '0.5rem',
		paddingTop: '1rem',
	},
	btnOn:{
		background: COLORS.blue,
		width: '10rem',
		color: '#fff',
		fontSize:"0.7rem",
		fontWeight: '600',
	    textTransform: 'none',
		'&:hover': {
			background: COLORS.blue,
		},
	},
	btnOff:{
		color: COLORS.blue,
		width: '10rem',
		background: '#fff',
		fontSize:"0.7rem",
		fontWeight: '600',
		textTransform: 'none',
		'&:hover': {
			background: COLORS.gray,
		},
	},
	reportBtn:{
		position: 'fixed',
	    justifyContent: 'center',
		fontSize: '0.875rem',
		padding: '0.6rem',
		textTransform: 'none',
		backgroundColor: COLORS.blue,
		fontWeight: '600',
		color: '#fff',
		margin: '1rem',
		"&:hover": {
			backgroundColor: COLORS.blue
	  	} 
	}
  }));

const Report = ({ cid, token, rank, cashierID, item, isReconciled, dateStart, dateEnd, processed }) => {
		const matches = useMediaQuery('(min-width:780px)')
  		const [activeTransactions, setActiveTransactions] = useState([])
		const [closedTransactions, setClosedTransactions] = useState([])
		const [reconciled, setReconciled] = useState(isReconciled)
		const [ cashierId, ] = useState(parseInt(rank)!==0?0:parseInt(cashierID))
		const [isLoading, setIsLoading] = useState(true)
		const [isConfirm, setIsConfirm] = useState(false)
		const [isFetched, setIsFetched] = useState(false)
		const [total, setTotal] = useState(0)
		const [popupShiftClose, setShiftClosePopup] = useState(false)
		const [popupSendReport, setSendReportPopup] = useState(false)
		const [isShiftClose, setIsShiftClose] = useState(false)
		const [startDate, setStartDate] = useState(dateStart)
		const [endDate, setEndDate] = useState(dateEnd)
		const [focus, setFocus] = useState(false)
		const [ popupIsModalLogout, setPopupIsModalLogout ] = useState(false)
		const [emptyDate, ] = useState("Od " + '01.' + moment(Date.now()).format("MM.") )
	 	const params = useParams()
		const navigate = useNavigate()
		const classes = useStyles()
		const currDate = new Date()
		const { detailsLst, setPrevPage, setPageNumber, setIsReconciled, setDateStart, setDateEnd,  resetPN, signOut, setProcessed } = useContext(AuthContext)

		// setup ref for your usage
		const myRef = useRef();
		const handlers = useSwipeable({ onSwipedLeft: () => handleLeftSwipe(), onSwipedRight: () => handleRightSwipe() })

		const handleLeftSwipe = () => {
				resetPN()
				navigate(`/kekspos/${params.tid}`)
		}

		const handleRightSwipe = () => {
			if(item!==null)
			{
					setPageNumber(4)
					setTimeout(() => 
					{
						navigate(`/kekspos/${params.tid}/detalji/${item.keksId}`)
					}, 0)
			}
		}
	
		const refPassthrough = (el) => {
				// call useSwipeable ref prop with el
				handlers.ref(el)
				// set myRef el so you can access it yourself
				myRef.current = el
		}

		const closeShift = async () => {
			const config = {
				headers:{
				  'X-Session-Token':token
				}
			  };
			return await axios.post(getHostName() + '/cashier/close', {tid:params.tid, id:cashierId},config)
			.then(response => {
					console.log("response: ", response.data )
					return response.data
		 	}).catch(error => {
					  console.log("Error happend while requesting the data...")
		  	})
		}

		const handleShiftClose = async () => {
				setShiftClosePopup(false)
				setIsLoading(true)
				await closeShift().then(res=>{
					if(res.resultCode===0){
						setIsLoading(false)	
						setIsShiftClose(true)
						setIsConfirm(true)
				 		if(res.result){
							setProcessed(true)
				 		}else{
				 			console.log("Neuspjelo zatvranje smjene!")
							setProcessed(false)
				 		}
					}else{
							setTimeout(() => setIsLoading(false), 1000)
                        	setPopupIsModalLogout(true)
					}
				 				
				 })
		}

		const handleSendReport = async () => {
				console.log("Send report..., closedTransactions array")
				setSendReportPopup(false)
				setIsConfirm(true)
				setIsShiftClose(false)
		}

		const handleActiveTransactions = () => {
			if(reconciled){
				setReconciled(false)
				setIsReconciled(false)
				setIsLoading(true)
				setIsFetched(false)	
			} 
		}

		const handleClosedTransactions = () => {
			if(!reconciled){
				setReconciled(true)
				setIsReconciled(true)
				setIsLoading(true)
				setIsFetched(false)	
			}
		}

		const fetchClosedTransactions = async (event) => {
				event.preventDefault()
				setIsLoading(true)
				getClosedTransactions().then(apiData => {
					if(apiData.resultCode===0){
						setClosedTransactions(apiData.result)
						setIsLoading(false)
						setIsFetched(true)
					}else{
						setTimeout(() => setIsLoading(false), 1000)
                        setPopupIsModalLogout(true)
					}
				})						 
		}

		const getActiveTransactions = async () => {
				return await axios.post(getHostName() + '/advice_list', 
					{tid:params.tid, token:token, reconciled:reconciled, id:cashierId})
				.then(response => {
						console.log("response: ", response.data )
						var sum=0
						if(response.data.result.length>0){		
							for(let num in response.data.result){
								var currDate = new Date()
								let tmpAmount = response.data.result[num].amount - response.data.result[num].amountVoided
								if(currDate.getFullYear()!==2022&&(response.data.result[num].epochtime/1000)<1672531200)
								{
									 tmpAmount/=7.5345
								}
								 
								sum+=tmpAmount
								 
							}
						}
					setTotal(sum)
					return response.data
				}).catch(error => {
					  console.log("Error happend while requesting the data...")
		  		})
		}

		const getClosedTransactions = async () => {
			var start = moment(Date.now()).format("YYYY-MM") + '-01'
			if(startDate===null && endDate===null){
				return await axios.post(getHostName() + '/advice_list', 
					{ tid:params.tid, token:token, start:start, id:cashierId })
					.then(response => {
						console.log("response: ", response.data )
						return response.data
					}).catch(error => {
					 	 console.log("Error happend while requesting the data...")
				})
			}else{
				if(startDate===null){
					setDateStart(start)
					return await axios.post(getHostName() + '/advice_list',
								{ tid:params.tid, token:token, start:start, end:endDate, id:cashierId })
					.then(response => {
						return response.data
					}).catch(error => {
					 	 console.log("Error happend while requesting the data...")
					})
					 
				}else{
					return await axios.post(getHostName() + '/advice_list',
								{ tid:params.tid, token:token, start:startDate, end:endDate, id:cashierId })
					.then(response => {
						console.log("response: ", response.data )
						return response.data
					}).catch(error => {
					 	 console.log("Error happend while requesting the data...")
					})
				}
			}		 
		}

  		useEffect(() => {
			setIsLoading(true)
			if(!reconciled){
				getActiveTransactions().then(apiData => {
					if(apiData.resultCode===0){
						setActiveTransactions(apiData.result)
						setIsLoading(false)

					}else{
						setTimeout(() => setIsLoading(false), 1000)
                        setPopupIsModalLogout(true)
					}		
				})
			}else{
				getClosedTransactions().then(apiData => {
					if(apiData.resultCode===0){
						setClosedTransactions(apiData.result)
						setIsLoading(false)
					}else{
						setTimeout(() => setIsLoading(false), 1000)
                        setPopupIsModalLogout(true)
					}
				})	
			}
		},[reconciled])

		useEffect(() => {
			setPrevPage({prevPageNum:7})
			window.addEventListener('popstate', onBackButtonEvent)
		 
			return () => {
					window.removeEventListener('popstate', onBackButtonEvent);
			}
	  	}, [])

		const onBackButtonEvent = (e) => {
				e.preventDefault()
	 			setPageNumber(null)
				navigate(`/kekspos/${params.tid}`)	 
		}

		useEffect(() => 
        {   
            const handleReload = async (e) => 
            {
                e.preventDefault()
                signOut(cid)
                setTimeout(() => window.location.assign(`/kekspos`, 0));
				window.removeEventListener('beforeunload', handleReload) 
                return false
            }

            window.addEventListener("beforeunload", handleReload)
         
            return () => 
            {    
                window.removeEventListener('beforeunload', handleReload) 
            }
  
  	    }, [])

		const handleDetails = (item) => {
				var start = moment(Date.now()).format("YYYY-MM") + '-01'
				setDateStart(startDate!==null?startDate:start)
				detailsLst(item)
  		}

		const handleStartDate = (e) => {
				setDateStart(e)
				setStartDate(e)
		}

		const handleEndDate = (e) =>{
				setDateEnd(e)
				setEndDate(e)
		}

		const handleBackToReport = () => {
				setIsConfirm(false)
				if(processed){
					setIsReconciled(true)
					setReconciled(true)
				}else{
					setIsReconciled(false)
					setReconciled(false)
				}
		}

		const handleLogout = () => {
			setPopupIsModalLogout(false)
			setIsLoading(true)
			setTimeout(() => setIsLoading(false), 1000)
			resetPN()
			setTimeout(() => window.location.assign(`/kekspos/`, 0))
	  }

	if(!isLoading&&!isConfirm){
  	return (
    	<div className="report" {...handlers} ref={refPassthrough}>
				{popupShiftClose&&<ModalShiftClose popup={popupShiftClose}
							 total={total}
							 start={activeTransactions[activeTransactions.length-1].epochtime}
							 end={activeTransactions[0].epochtime}
							 onConfirmation={() => handleShiftClose()}
							 onClose={() => setShiftClosePopup(false)}
				/>}
				{popupSendReport&&<ModalSendReport popup={popupSendReport}
							 start={closedTransactions[closedTransactions.length-1].epochtime}
							 end={closedTransactions[0].epochtime}
							 onConfirmation={() => handleSendReport()}
							 onClose={() => setSendReportPopup(false)}
				/>}
				<ModalLogoutAlert popup={popupIsModalLogout} onClose={()=>handleLogout()} />
			<div className="report-main" {...handlers} ref={refPassthrough}>
				<div className="report-header">
					<Header pageNumber={7} />
					<ButtonGroup className={!reconciled?classes.btnGroupActive:classes.btnGroupClosed}>
							<Button size="medium"
									className={!reconciled?classes.btnOn:classes.btnOff}
									onClick = {() => handleActiveTransactions()}
							>Aktivna smjena</Button>
							<Button size="medium"
									className={reconciled?classes.btnOn:classes.btnOff}
									onClick = {() => handleClosedTransactions()}
							>Završene transakcije</Button>
					</ButtonGroup>
					{!reconciled?(<div className="report-title">
										<TotalReport />
										<div className="report-title-txt">Ukupni iznos aktivne smjene: <span>{parseFloat(total).toFixed(2)} EUR</span></div>
								</div>
								):(
								<MuiPickersUtilsProvider utils={DateFnsUtils}>
									<form className={classes.container} noValidate onSubmit={(event) => fetchClosedTransactions(event)}>
  										<KeyboardDatePicker
											disableToolbar
            								margin="normal"
            								label="Početni datum"
											emptyLabel={emptyDate}
											format="dd.MM."
											className={classes.textField1}
											style={{width:!isMobile?'20rem':'35%'}}
											inputVariant="outlined"
											inputProps={{ style: { fontSize: "0.83rem" } }}
            								value={startDate}
											onChange={(e)=>handleStartDate(e)}
											keyboardIcon={<ArrowDown style={{marginRight:'-1rem'}}/>}
											id="date-picker-inline"
											InputLabelProps={{
													shrink: true,
													style: {
														color: COLORS.blue
														}
											}}					   
             							/>
										<KeyboardDatePicker
            								margin="normal"
											disableToolbar
											emptyLabel="Do"
            								label="Krajnji datum"
											format="dd.MM."
											className={classes.textField2}
											style={{width:!isMobile?'20rem':'35%'}}
											inputVariant="outlined"
											inputProps={{ style: { fontSize: "0.83rem" } }}
            								value={endDate}
											onChange={(e)=>handleEndDate(e)}
											keyboardIcon={<ArrowDown style={{marginRight:'-1rem'}}/>}
											InputLabelProps={{
												shrink: true,
												style: {
													color: COLORS.blue
														}
											}}				 
             							/>
										<Button 
											type="sumbmit"
											variant="contained"
											size="small"
											disabled={endDate===null?true:false}
											style={{
												height:'3.23rem',
												marginTop: '1rem',
											 	backgroundColor: endDate===null?'#ccc':COLORS.blue,
												marginLeft: '0.6rem',
											}}
										><Search/></Button> 
									</form>
								</MuiPickersUtilsProvider>
					)}
					<Divider style={{width:'100%'}}/>
				</div>
				<div className="report-body">
					<div className="report-table" style={{height:!reconciled?'75vh':'78vh'}}>
					<Table stickyHeader className={classes.table} aria-label="sticky table" size="small">
                        <TableHead style={{zIndex:(popupShiftClose||popupSendReport)?'-1':'1'}}>
							<TableRow>
							{matches&&<TableCell style={{width:'15%'}} component="td" scope="row"/>} 
                                <TableCell className={classes.idHead}
											style={{width:matches?'20%':'30%'}} 
											component="td" 
											scope="row"
											align="left" 
								>ID računa</TableCell>
                                <TableCell  className={classes.dateHead} 
											style={{width:matches?'30%':'40%'}} 
											component="td" 
											scope="row" 
											align="center"
								>Datum i vrijeme</TableCell>
                                <TableCell className={classes.amountHead} 
											style={{width:(reconciled&&closedTransactions.length!==0)?(matches?'20%':'25%'):(matches?'20%':'40%')}} 
											component="td" 
											scope="row" 
											align="right"
								>Iznos</TableCell>
                                {(reconciled&&closedTransactions.length!==0)?<TableCell style={{width:matches?'15%':'5%'}} 
																						align="left" 
																						component="td" 
																						scope="row"/>:(matches?<TableCell component="td" 
																															scope="row"
																															style={{width:'15%'}}
																															/>:null)}
                            </TableRow> 
                        </TableHead>
                        <TableBody>
                            {!reconciled?(
                                activeTransactions.map((item, keksId)=>
                                    <TableRow key={keksId} className={classes.tableRow}>
										{matches&&<TableCell component="td" scope="row"/>} 
                                        <TableCell className={classes.idBody} 
													component="td" 
													scope="row" 
													align="left"
										>{item.keksId}</TableCell>
                                        <TableCell className={classes.dateBody}
                                                    component="td" 
                                                    scope="row" 
                                                    align="center"           
                                        >{moment(item.epochtime).format("DD.MM.YYYY HH:mm")}</TableCell>
                                        <TableCell className={classes.amountBody}
													style={{color:item.amountVoided===0?COLORS.green:'red'}} 
													component="td" 
													scope="row" 
													align="right"
										>{(item.epochtime/1000>1672531200?<div>{item.amount.toFixed(2)} EUR</div>:<div>{(item.amount/7.5435).toFixed(2)} EUR</div>)}</TableCell>
										{matches&&<TableCell component="td" scope="row" />} 
                                    </TableRow>) 
                                    ):(
                            	closedTransactions.map((item, keksId) =>
									<TableRow key={keksId}
											component={Link} 
											to={`/kekspos/${params.tid}/detalji/${item.keksId}`}
											className={classes.tableRow}
											style={{cursor:'pointer', textDecoration:'none'}}
											onClick={() => handleDetails(item)}>
										{matches&&<TableCell component="td" scope="row" />} 
										<TableCell className={classes.idBody} 
													component="td" 
													scope="row" 
													align="left"
										>{item.keksId}</TableCell>
										<TableCell className={classes.dateBody}
													component="td" 
													scope="row" 
													align="center"			  			 
										>{moment(item.epochtime).format("DD.MM.YYYY HH:mm")}</TableCell>
										<TableCell className={classes.amountBody}
													style={{color:item.amountVoided===0?COLORS.green:'red'}} 
													component="td" 
													scope="row" 
													align="right"
										>{(item.epochtime/1000>1672531200?<div>{item.amount.toFixed(2)} EUR</div>:<div>{(item.amount/7.5435).toFixed(2)} EUR</div>)}</TableCell>
										{closedTransactions.length!==0&&
											<TableCell className={classes.arrow} 
														component="td" 
														scope="row" 
														align="left"
											><Arrow/></TableCell>}
									</TableRow>) 
                                            )} 
                        </TableBody>     
                    </Table> 	 
					</div>
					{(!reconciled&&activeTransactions.length!==0)?
									<div className="report-btn">
										<Button size="large"
										 		variant="contained"
												className={classes.reportBtn}
												style={{top:isMobile?'85vh':'90vh', width:!isMobile?'25rem':'90%'}}
												onClick = {() => setShiftClosePopup(true)}
										>ZATVORI SMJENU</Button>
									</div>:null
					}
					{(isFetched&&closedTransactions.length!==0)?
									<div className="report-btn">
										<Button size="large"
												variant="contained"
												className={classes.reportBtn}
												style={{top:isMobile?'85vh':'90vh', width:!isMobile?'25rem':'90%'}} 
												onClick = {() => setSendReportPopup(true)}
										>POŠALJI IZVJEŠTAJ</Button>
									</div>
					:null}
	  			</div>
			</div>
    	</div>
  	)
	}else if(isConfirm&&!isLoading){ 
		return(
			<Confirmation cid={cid} 
						processed={processed} 
						isShift={isShiftClose} 
						pageNumber={7} 
						onBackToReport={() => handleBackToReport()}/>
		)
	}else if(!isConfirm&&isLoading){ 
		return(
			<Loading />
		)
	}
}

export default Report